import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
export const ShopHero = () => {
  return <div className="relative bg-blue-500 text-white overflow-hidden">
      <div className="container mx-auto px-4 py-12 flex items-center justify-between">
        <div className="max-w-xl">
          <h1 className="text-4xl font-bold mb-4">Fast Shipping with Obotan</h1>
          <p className="text-lg mb-6">
            Shop millions of products with quick delivery and exclusive deals
          </p>
          <Button variant="secondary" className="group">
            Join Now
            <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Button>
        </div>
        <div className="hidden lg:block">
          <div className="relative w-[400px] h-[300px]">
            <div className="absolute inset-0 bg-gradient-to-r from-blue-500/50 to-transparent" />
            <img src="/placeholder.svg" alt="Shopping benefits" className="w-full h-full object-cover rounded-lg" />
          </div>
        </div>
      </div>
      <div className="absolute inset-0 bg-grid-white/[0.05] bg-[size:16px_16px]" />
    </div>;
};